module.exports = __webpack_public_path__ + "img/9788993094688.be4974de.jpg";